import { useMutation } from '@tanstack/react-query';
import { saveAs } from 'file-saver';

import { useShowMessage } from '../core-ui';
import { useFetch } from './useFetch';

type Options = {
  onSuccess?: () => void;
};

export function useExport(url: string, options: Options = {}) {
  const showMessage = useShowMessage();
  const fetch = useFetch({ expectedType: 'text/csv' });

  const { mutate: doExport, isLoading } = useMutation(
    ['export', url],
    async (body: unknown = {}) => {
      const response = await fetch(url, { body });
      const contentDisposition =
        response.headers.get('Content-Disposition') ?? '';
      const match = contentDisposition.match(/^attachment; filename=(.*)$/);
      const filename = match?.[1] ?? 'export.csv';
      const blob = await response.blob();
      saveAs(blob, filename);
    },
    {
      onError: (error) => {
        showMessage(
          'error',
          t('Export failed: {error}', { error: String(error) }),
        );
      },
      onSuccess: () => {
        options.onSuccess?.();
      },
    },
  );

  return [doExport as (body?: unknown) => void, { isLoading }] as const;
}
